import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'modelo/:slug',
    loadComponent: () =>
      import(
        './features/apartment-model/apartment-model.component'
      ).then((m) => m.ApartmentModelComponent),
  },
  {
    path: 'apartamento/:id',
    loadComponent: () =>
      import('./features/apartment/apartment.component').then(
        (m) => m.ApartmentComponent,
      ),
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./features/contact/contact.component').then((m) => m.ContactComponent),
  },
  {
    path: 'aviso-de-privacidade',
    loadComponent: () =>
      import('./features/legal/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'politica-de-cookies',
    loadComponent: () =>
      import('./features/legal/cookie-policy.component').then((m) => m.CookiePolicyComponent),
  },
  {
    path: 'termos-e-condicoes',
    loadComponent: () =>
      import('./features/legal/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
